import {
  GET_ROLES_FAIL,
  GET_ROLES_SUCCESS,
  GET_ROLE_DETAIL_FAIL,
  GET_ROLE_DETAIL_SUCCESS,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAIL,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAIL,
  CLEAR_MESSAGE,
} from "./actionTypes"

const INIT_STATE = {
  roleList: [],
  roleDetail: {},
  error: {},
  message: "",
}

const roles = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        roleList: action.payload?.data,
      }

    case GET_ROLES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_ROLE_SUCCESS:
      return {
        ...state,
        roleList: [...state.roleList, action?.payload?.data || {}],
        message: action?.payload?.message || "",
      }

    case ADD_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ROLE_DETAIL_SUCCESS:
      return {
        ...state,
        roleDetail: action.payload,
      }

    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        message: "Successfully role updated!",
        roleList: state.roleList.map(role => {
          return role._id.toString() === action.payload?.data._id.toString()
            ? { role, ...action.payload?.data }
            : role
        }),
      }

    case UPDATE_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ROLE_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    default:
      return state
  }
}

export default roles
